import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/tile.js';
import s from 'components/bolt/hub/components/carousel/tile.sss';

export default class Tile extends BaseComp.default {
	render(props) {
		const baseJSX = super.render(props);
		if (props.isCategory) {
			baseJSX.attributes.class += ' ' + s.category;
		}
		return baseJSX;
	}
}
